import { useEffect, useState } from "react";
import '../Styles/EditReview.scss'
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import DateHelpers from '../Helper/DateHelpers.js';
import React from "react";



function EditReview() {

   const [existingInformation, setExistingInformation] = useState({
      firstName: '',
      lastName: '',
      title: '',
      gender: '',
      strAddress: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      buddyName: '',
      buddyBirthDate: '',
      ecName: '',
      ecRelationship: '',
      ecPhone: '',
      groupCode: '',
      birthDate: '',
      guestPrefMail: 'off',
      insuranceCompany: '',
      insuranceId: '',
      groupPolicyNumber: '',
      policyHolderName: '',
      policyHolderBirthdate: '',
      isInsured: '',
      hasDiabetes: true,
      hasHeartCondition: 'off',
      hasEpilepsy: 'off',
      hasEnvironmentAllergies: 'off',
      hasHeatExhaustion: 'off',
      hasThyroidProblem: 'off',
      hasLupus: 'off',
      hasHighBloodPressure: 'off',
      hasAsthma: 'off',
      drugAllergies: '',
      emergencyAction1: '',
      foodAllergies: '',
      emergencyAction2: '',
      allergicReactions: '',
      otherAllergies: '',
      emergencyAction3: '',
      medicationName: '',
      medicationDose: '',
      tetanusShotDate: ''
   });
   const getUpdateInformation = async () => {
      try {

         const response2 = await fetch('/api/get-user', {
            method: 'GET',
            headers: { "Content-Type": "application/json" }
         })

         if (response2.status === 400 || response2.status === 500) {
            throw new Error("Failed User Retrieval");
         }

         const account = await response2.json();

         const response = await fetch('/getindividualinformation', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(
               {
                  email: account.user.email
               }
            )
         })

         // This will be updated with UseEffect                       // 
         const individualJSON = await response.json();
         const individualData = individualJSON.data[0];
         console.log("Indvidual Data", individualData)
         // Here is the info that is returning!

         setExistingInformation({
            ...existingInformation,
            firstName: individualData.first_name,
            lastName: individualData.last_name,
            gender: individualData.gender,
            strAddress: individualData.mail_addr_1,
            city: individualData.mail_city,
            state: individualData.mail_state,
            zip: individualData.mail_zip,
            phone: individualData.phone_num,
            email: individualData.email_address,
            ecName: individualData.emergency_cont_name,
            ecRelationship: individualData.emergency_cont_rel,
            ecPhone: individualData.emergency_cont_num,
            birthDate: individualData.birth_date,
            policyHolderBirthdate: individualData.policy_holder_bd,
            tetanusShotDate: individualData.last_tetanus_shot_date,
            insuranceCompany: individualData.insurance_cmpy,
            insuranceId: individualData.insurance_id_num,
            groupPolicyNumber: individualData.insurance_group_num,
            policyHolderName: individualData.policy_holder_name,
            isInsured: true,
            hasDiabetes: individualData.has_diab_or_hypgly,
            hasHeartCondition: individualData.has_heart_condition,
            hasEpilepsy: individualData.has_epilepsy,
            hasEnvironmentAllergies: individualData.has_env_allergies,
            hasHeatExhaustion: individualData.has_heat_problem,
            hasThyroidProblem: individualData.has_thyroid_problem,
            hasLupus: individualData.has_lupus,
            hasHighBloodPressure: individualData.has_high_blood_pressure,
            hasAsthma: individualData.has_asthma
         })
         console.log("Here's Existing Info", existingInformation)
      }
      catch (error) {
         console.log("An error occurred in the submission of create individual account")
      }
   };

   useEffect(() => {
      getUpdateInformation();
   }, []);

   return (
      <div className="editReviewContent">
         <Helmet>
            <title>Review Individual Account - Camp Connect</title>
         </Helmet>
         <div className="editReviewContainer">

            <table className="editReviewTable">
               <tr>
                  <h1>Review Account Information</h1>
               </tr>
               <tr>
                  <th>First Name</th>
                  <td>{existingInformation.firstName}</td>
               </tr>
               <tr>
                  <th>Last Name</th>
                  <td>{existingInformation.lastName}</td>
               </tr>
               <tr>
                  <th>Date of Birth</th>
                  <td>{DateHelpers.getDisplayDate(existingInformation.birthDate)}</td>
               </tr>
               <tr>
                  <th>Email Address</th>
                  <td>{existingInformation.email}</td>
               </tr>
               <tr>
                  <th>Phone Number</th>
                  <td>{existingInformation.phone}</td>
               </tr>
               <tr>
                  <th>City</th>
                  <td>{existingInformation.city}</td>
               </tr>
               <tr>
                  <th>State</th>
                  <td>{existingInformation.state}</td>
               </tr>
               <tr>
                  <th>Zip Code</th>
                  <td>{existingInformation.zip}</td>
               </tr>
               <tr>
                  <th>Emergency Contact Name</th>
                  <td>{existingInformation.ecName}</td>
               </tr>
               <tr>
                  <th>Emergency Contact Relationship</th>
                  <td>{existingInformation.ecRelationship}</td>
               </tr>
               <tr>
                  <th>Emergency Contact Phone</th>
                  <td>{existingInformation.ecPhone}</td>
               </tr>
               <tr>
                  <th>Has Diabetes/ Hypoblycemia</th>
                  <td>{existingInformation.hasDiabetes ? "yes" : "no"}</td>
               </tr>
               <tr>
                  <th>Has Epilepsy</th>
                  <td>{existingInformation.hasEpilepsy ? "yes" : "no"}</td>
               </tr>
               <tr>
                  <th>Has Enviromental Allergies</th>
                  <td>{existingInformation.hasEnvironmentAllergies ? "yes" : "no"}</td>
               </tr>
               <tr>
                  <th>Has Heat Exhaustion/Problems</th>
                  <td>{existingInformation.hasHeatExhaustion ? "yes" : "no"}</td>
               </tr>
               <tr>
                  <th>Has Thyroid Problems</th>
                  <td>{existingInformation.hasThyroidProblem ? "yes" : "no"}</td>
               </tr>
               <tr>
                  <th>Has Lupus</th>
                  <td>{existingInformation.hasLupus ? "yes" : "no"}</td>
               </tr>
               <tr>
                  <th>Has High Blood Pressure</th>
                  <td>{existingInformation.hasHighBloodPressure ? "yes" : "no"}</td>
               </tr>
               <tr>
                  <th>Has Asthma</th>
                  <td>{existingInformation.hasAsthma ? "yes" : "no"}</td>
               </tr>
            </table>
            <div className="editPageHr">
               <hr></hr>
            </div>

            <div className="editreviewbuttonbox">
               <Link to={'/updateindividualinformation'}>
                  <button>
                     Re-Edit Personal Information
                  </button>
               </Link>
            </div>

            <div className="accountbuttonbox">
               <Link to={'/individualaccount'}>
                  <button>
                     Confirm Personal Information
                  </button>
               </Link>
            </div>
         </div>
      </div>
   )
}

export default EditReview; 
